import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class SubscriptionKeyInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isMonolithRequest(req.url)) {
      return next.handle(req);
    }

    const clonedRequest = req.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': environment.subscriptionKey
      }
    });
    return next.handle(clonedRequest);
  }

  private isMonolithRequest(url: string): boolean {
    try {
      const monolithHost = new URL(environment.adminApiUrl).hostname;
      const requestHost = new URL(url).hostname;
      return monolithHost === requestHost;
    } catch {
      return false;
    }
  }
}
